function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from '../Button';
import { Dropdown } from '../Dropdown';
import styles from '@dtsl/css-pagination/dist/index.module.css';
import ArrowLeft from '@dtsl/icons/dist/icons/react/ArrowLeft';
import ArrowRight from '@dtsl/icons/dist/icons/react/ArrowRight';
const types = {
  INCREMENT: 'increment',
  DECREMENT: 'decrement'
};
const defaultInitialRow = {
  label: '50',
  value: 50
};
function Pagination(_ref) {
  let {
    showRowsPerPage = false,
    title = 'Rows per page',
    secondaryText = 'of',
    rowList = [{
      label: '20',
      value: 20
    }, {
      label: '50',
      value: 50
    }, {
      label: '100',
      value: 100
    }],
    initialRow = defaultInitialRow,
    currentPage = '1',
    totalResults = 250,
    onChange = () => {},
    clickNext = () => {},
    clickPrev = () => {},
    onSelect = () => {},
    dropdownMetaData = {}
  } = _ref;
  const [selected, setSelected] = useState([initialRow]);
  const rowCountNum = Number(selected[0].value);
  const endRangeCount = Math.min(totalResults, rowCountNum);
  const [pageRange, setPageRange] = useState([1, endRangeCount]);
  const [total, setTotal] = useState(totalResults);
  const currentPageInt = parseInt(currentPage);
  const totalPages = Math.ceil(totalResults / rowCountNum);
  const singleSelectionOptions = rowList;
  const defaultOption = selected;
  useEffect(() => {
    setSelected([initialRow]);
  }, [initialRow]);
  useEffect(() => {
    if (totalResults) {
      setTotal(totalResults);
      if (totalResults <= selected[0].value) {
        setPageRange([1, parseInt(totalResults)]);
      } else {
        setPageRange([Math.max(1, (currentPageInt - 1) * rowCountNum + 1), Math.min(currentPageInt * rowCountNum, totalResults)]);
      }
    }
  }, [currentPageInt, rowCountNum, totalResults]);
  const _onSelect = option => {
    onChange(option);
    if (Array.isArray(option)) {
      setSelected(option);
      return;
    }
    setSelected([option]);
  };
  function changePage(type) {
    if (type === types.DECREMENT) {
      clickPrev();
    } else if (type === types.INCREMENT) {
      clickNext();
    }
  }
  const onPageClick = page => {
    onSelect(page);
  };
  const navigationLink = () => {
    if (totalPages === 1) {
      return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
        className: `${styles['sib-pagination-link']} ${styles['is-active']}`,
        "aria-label": "page 1",
        "aria-current": "true"
      }, "1"));
    }
    if (totalPages <= 5) {
      let totalPagesArr = [];
      for (let i = 1; i <= totalPages; i++) {
        totalPagesArr.push(i);
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, totalPagesArr.map((page, index) => {
        if (page === currentPageInt) {
          return /*#__PURE__*/React.createElement("li", {
            key: `k-${index}`
          }, /*#__PURE__*/React.createElement("button", {
            className: `${styles['sib-pagination-link']} ${styles['is-active']}`,
            "aria-current": "true",
            "aria-label": `page ${page}`
          }, page));
        } else {
          return /*#__PURE__*/React.createElement("li", {
            key: `k-${index}`
          }, /*#__PURE__*/React.createElement("button", {
            className: `${styles['sib-pagination-link']} ${styles['hr']}`,
            onClick: () => {
              onPageClick(page);
            },
            onKeyDown: event => {
              if (event.key === 'Enter') {
                onPageClick(page);
              }
            },
            "aria-label": `page ${page}`
          }, page));
        }
      }));
    }
    if (totalPages > 5) {
      let totalPagesArr = [];
      if (currentPageInt <= 3) {
        totalPagesArr = ['1', '2', '3', '...', `${totalPages}`];
      } else if (currentPageInt > totalPages - 3) {
        totalPagesArr = ['1', '...', `${totalPages - 2}`, `${totalPages - 1}`, `${totalPages}`];
      } else {
        totalPagesArr = ['1', '...', `${currentPageInt}`, '...', `${totalPages}`];
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, totalPagesArr.map((page, index) => {
        if (parseInt(page) === parseInt(currentPage)) {
          return /*#__PURE__*/React.createElement("li", {
            key: `k-${index}`
          }, /*#__PURE__*/React.createElement("button", {
            className: `${styles['sib-pagination-link']} ${styles['is-active']}`,
            "aria-current": "true",
            "aria-label": `page ${page}`
          }, page));
        } else if (page === '...') {
          return /*#__PURE__*/React.createElement("li", {
            key: `k-${index}`
          }, /*#__PURE__*/React.createElement("button", {
            className: styles['sib-pagination-help-text'],
            "aria-label": `page ${page}`
          }, "..."));
        } else {
          return /*#__PURE__*/React.createElement("li", {
            key: `k-${index}`
          }, /*#__PURE__*/React.createElement("button", {
            className: styles['sib-pagination-link'],
            onClick: () => onPageClick(`${page}`),
            onKeyDown: event => {
              if (event.keyCode === 13) {
                onPageClick(page);
              }
            },
            "aria-label": `page ${page}`
          }, page));
        }
      }));
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles['sib-pagination']
  }, showRowsPerPage ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: styles['sib-pagination-title']
  }, title), /*#__PURE__*/React.createElement("div", {
    className: styles['sib-pagination-dropdown']
  }, /*#__PURE__*/React.createElement(Dropdown, _extends({
    key: 'singleSelection',
    options: singleSelectionOptions,
    onSelect: _onSelect,
    value: defaultOption,
    inlineDropdownStyles: {
      width: '72px'
    }
  }, dropdownMetaData)))) : null, /*#__PURE__*/React.createElement("div", {
    className: styles['stats__wrapper']
  }, /*#__PURE__*/React.createElement("strong", {
    className: styles['stats__range']
  }, pageRange.join('-')), ' ', secondaryText, " ", total), /*#__PURE__*/React.createElement("nav", {
    className: styles['sib-pagination-links-wrapper'],
    "aria-label": "pagination nevigation"
  }, /*#__PURE__*/React.createElement("ul", {
    className: styles['sib-pagination-links']
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Button, {
    icon: /*#__PURE__*/React.createElement(ArrowLeft, null),
    ariaLabel: "Left arrow",
    iconAlone: true,
    variant: "tertiary",
    label: "button",
    style: {
      marginRight: '8px'
    },
    disabled: currentPageInt === 1 || currentPageInt === 0 || totalPages === 1,
    onClick: () => changePage(types.DECREMENT)
  })), navigationLink(), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Button, {
    icon: /*#__PURE__*/React.createElement(ArrowRight, null),
    iconAlone: true,
    variant: "tertiary",
    ariaLabel: "Right arrow",
    label: "button",
    disabled: currentPageInt === totalPages || totalPages === 1,
    onClick: () => changePage(types.INCREMENT)
  })))));
}
Pagination.propTypes = {
  showRowsPerPage: PropTypes.bool,
  title: PropTypes.string,
  secondaryText: PropTypes.string,
  rowList: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number
  })),
  initialRow: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number
  }),
  currentPage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  totalResults: PropTypes.number,
  onChange: PropTypes.func,
  clickPrev: PropTypes.func,
  clickNext: PropTypes.func,
  onSelect: PropTypes.func,
  dropdownMetaData: PropTypes.object
};
export default Pagination;